import dynamic from 'next/dynamic';
import ExpansibleContentBase from '../components/expandible-table-items-base/extensible-content-base';
import ItemExpansibleBase from '../components/expandible-table-items-base/item-expandible-base';
import PriceTagItem from '../components/price-tag/price-tag-item';
import PropTypes from 'prop-types';
import RangeIndicator from '../components/slider-indicator/slider-indicator';
import styles from 'styles/LandingTablesComponents.module.scss';
import styles1 from 'styles/LandingExpansibleTable.module.scss';
import useRichTranslation from 'hooks/useRichTranslation';
import { useState } from 'react';
import variables from 'styles/variables.module.scss';

const CarIconMapper = dynamic(() => import('components/icons/landing/car-brand-icons/mapper'));

const QuotationByCarCategoryItem = ({
    carBrand,
    carName,
    colorSchema,
    familyName,
    itemsCount,
    price,
    totalItems
}) => {
    const [isBacksideOpen, setBacksideOpen] = useState(false);
    const t = useRichTranslation();

    /** Function that toggle the backside Item visibility */
    function showBacksideHandler () {
        setBacksideOpen(true);
    }

    /** Function that toggle the backside Item visibility */
    function hideBacksideHandler () {
        setBacksideOpen(false);
    }

    return (
        <ItemExpansibleBase
            disableArrows
            colorSchema={colorSchema}
            carName={carName}
            isBacksideOpen={isBacksideOpen}
            showBacksideHandler={showBacksideHandler}
            hideBacksideHandler={hideBacksideHandler}
            ctaLabel={t('table.quotation-by-car-category.more-info')}
            ctaHref={t('quoter')}
            topNode={
                <>
                    <CarIconMapper input={carBrand} color={variables.whiteColor} height={22} />
                    <p
                        style={{ marginBottom: 0 }}
                        className={`${styles.label} ${styles.top}`}
                    >
                        {carName}
                    </p>
                </>
            }
            upperNode={
                <PriceTagItem
                    tagType="price-label"
                    value={`${Math.round(price)}`}
                    fontSize={20}
                    color="#000"
                />
            }
            bottomNode={
                <div className={`${styles1.bottom_wrapper} ${styles1.item}`}>
                    <p>
                        <strong>{itemsCount}</strong>
                        {'\t'}
                        {t('table.quotation-by-car-category.of')}
                        {'\t'}
                        <strong>{totalItems}</strong>
                        {'\t'}
                        {t('table.quotation-by-car-category.items-covered')}
                    </p>
                    <RangeIndicator
                        range={totalItems}
                        width={140}
                        value={itemsCount}
                        colorSchema={colorSchema}
                    />
                </div>
            }
        >
            <ExpansibleContentBase isOpen={false}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <p
                        style={{ fontSize: 12, marginBottom: 0 }}
                        className={`${styles.label} ${styles.item}`}
                    >
                        <strong>{familyName}</strong>
                    </p>
                </div>
            </ExpansibleContentBase>
        </ItemExpansibleBase>
    );
};

QuotationByCarCategoryItem.propTypes = {
    carBrand: PropTypes.string,
    carName: PropTypes.string,
    colorSchema: PropTypes.string,
    familyName: PropTypes.string,
    itemsCount: PropTypes.number,
    price: PropTypes.number,
    totalItems: PropTypes.number
};

export default QuotationByCarCategoryItem;
